import script from "./ChatMessageVersionNav.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatMessageVersionNav.vue?vue&type=script&setup=true&lang=js"

import "./ChatMessageVersionNav.vue?vue&type=style&index=0&id=917345d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917345d6"]])

export default __exports__